import { SplitFactory } from "@splitsoftware/splitio";
import { setFeatureFlags } from "../store/reducers/split";
import {
  REACT_APP_SPLIT_PRODUCTION_KEY_ENC,
  REACT_APP_SPLIT_STAGING_KEY_ENC,
} from "../constants";
import { environment } from "./../http";
import { decrypt } from ".";

export const splitClient = (customerId) => {
  const factory = SplitFactory({
    core: {
      authorizationKey:
        environment === "production"
          ? decrypt(REACT_APP_SPLIT_PRODUCTION_KEY_ENC)
          : decrypt(REACT_APP_SPLIT_STAGING_KEY_ENC), // Replace with your actual key
      key: customerId, // Pass customer-specific key
    },
  });

  return factory.client();
};

export const initSplitAndDispatch = (userId, dispatch) => {
  const user = splitClient(userId);

  user.on(user.Event.SDK_READY, () => {
    const billingTreatment = user.getTreatment("billing");
    const isBillingEnabled = billingTreatment === "on";
    dispatch(setFeatureFlags({ billing: isBillingEnabled }));
  });

  user.on(user.Event.SDK_READY_TIMED_OUT, () => {
    dispatch(setFeatureFlags({ billing: false }));
  });

  return user;
};
